import { useMemo } from "react";

import { PalDatePicker, PalPage } from "@palamar/fe-library";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import styled from "@emotion/styled";
import { Grid } from "@mui/material";

import { setFigureFilter } from "~store/figures/actions";
import { selectSingleFilter } from "~store/figures/selectors";

const StyledPalDatePicker = styled(PalDatePicker)`
  border-top-left-radius: auto;
  ${({ theme }) => theme.breakpoints.down("md")} {
    &.MuiTextField-root {
      width: 100%;
    }
  }
`;

const DateFilter = ({ params, props }) => {
  const filterName = useMemo(() => params?.[0], [params]);
  const selectedDate = useSelector(selectSingleFilter(filterName));

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDateChange = (newValue) => {
    dispatch(setFigureFilter({ [selectedDate]: newValue }));
  };

  return (
    <PalPage>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StyledPalDatePicker label={t("common.date")} value={selectedDate} onChange={handleDateChange} {...props} />
        </Grid>
      </Grid>
    </PalPage>
  );
};

export default DateFilter;
